/*
 * @author Mateusz Mieszczak <mateusz.mieszczak at bossbyte.com>
 * @copyright BossByte Web Application
 */


app.controller('AdminReciverEdit', function($rootScope, $scope, $http, $location, _$toast, $stateParams, $mdDialog, _$breadcrumbs, recipientService) {
    $scope.tabIndex = 0;
    $scope.group = {
        admin_group: true,
        filter: {
            all: true
        }
    };
    $scope.subunits = [];
    $scope.data = {
      "activeNotifications": []
    };

    $scope.tab = {
        "change": function(kind, form) {
            var result = true;
            if (typeof form != "undefined") {
                result = $scope.checkForm(form);
            }
            if (result)
                $scope.tabIndex = kind == 'next' ? $scope.tabIndex + 1 : $scope.tabIndex - 1;
        }
    };

    $scope.save = function() {
        var params = angular.copy($scope.group);

        if ($scope.autocomplete.city.length > 0)
            params.filter.city = _.map($scope.autocomplete.city, 'name').join();
        if ($scope.autocomplete.county.length > 0)
            params.filter.county = _.map($scope.autocomplete.county, 'name').join();
        if ($scope.autocomplete.comunity.length > 0)
            params.filter.comunity = _.map($scope.autocomplete.comunity, 'name').join();
        if ($scope.autocomplete.street.length > 0)
            params.filter.street = _.map($scope.autocomplete.street, 'name').join();

        if (typeof params.filter.age_before == "object")
            params.filter.age_before = $rootScope.formatDate(params.filter.age_before);
        if (typeof params.filter.age_after == "object")
            params.filter.age_after = $rootScope.formatDate(params.filter.age_after);

        if (typeof $scope.group.subunits != "undefined" && $scope.group.subunits.length > 0)
            params.filter.unit_id = $scope.group.subunits.join();

        $http.post('/administration/recivers/save', params)
            .success(function(result) {
                _$toast.message(result.msg);
                if (result.code == 1 && $stateParams.action == 'new')
                    $location.path('/app/administration/recivers');
            });
    };

    $scope.delete = function() {
        $http.post('/administration/recivers/delete', {
                id: $stateParams.id
            })
            .success(function() {
                $location.path('/app/administration/recivers');
            });
    };

    $scope.duplicate = function() {
        $mdDialog.show({
            controller: DuplicateDialog,
            templateUrl: 'duplicate.html',
            locals: {
                id: $stateParams.id
            }
        });

    };

    function DuplicateDialog($scope, $mdDialog, locals, $http) {
        $scope.name = '';

        $scope.confirm = function() {
            $http.post('/administration/recivers/duplicate', {
                    id: locals.id,
                    name: $scope.name
                })
                .success(function(result) {
                    _$toast.message(result.msg);
                    $location.path('/app/administration/recivers');
                });
            $mdDialog.hide();
        };

        $scope.cancel = function() {
            $mdDialog.cancel();
        };
    };


    $scope.autocomplete = {
        comunity: [],
        county: [],
        city: [],
        street: []
    };

    $scope.selcted = function(subunit) {
        for (var i in $scope.group.subunit) {
            if ($scope.group.subunit[i] == subunit.id)
                return true;
        }
        return false;
    };

    $scope.checkForm = function(form) {
        if (form.$valid) {
            return true;
        } else {
            angular.forEach(form.$error, function(field) {
                angular.forEach(field, function(f) {
                    f.$setDirty();
                    f.$setTouched();
                });
            });
            $rootScope.notification.show('error', 'Formularz nie został prawidłowo wypełniony');
            return false;
        }
    };

    /*
     * INIT
     */
    $scope.show = false;
    $scope._init = function() {
        $scope.action = $stateParams.action;
        $http.post('/administration/unit/getlist', {
            subunit: true
        }).success(function(result) {
            $scope.subunits = result;

            if (!_.isUndefined($stateParams.id)) {
                _$breadcrumbs.push('Edycja grupy');
                $http.get('/administration/recivers/get/' + $stateParams.id)
                    .success(function(response) {
                        $scope.data.activeNotifications = response.activeNotifications;
                        $scope.group.id = response.group.id;
                        $scope.group.description = response.group.description;
                        $scope.group.group_name = response.group.group_name;
                        $scope.group.active = response.group.active == 1;
                        $scope.group.filter = response.filter;

                        $scope.group.subunit = [];
                        for (var i in response.group.unit)
                            $scope.group.subunit.push(response.group.unit[i].id);

                        if (!_.isNull($scope.group.filter.age_before))
                            $scope.group.filter.age_before = new Date($scope.group.filter.age_before);
                        if (!_.isNull($scope.group.filter.age_after))
                            $scope.group.filter.age_after = new Date($scope.group.filter.age_after);

                        var county = $scope.group.filter.county;
                        if (county) {
                            county = county.split(",");
                            for (var i = 0; i < county.length; i++) {
                                if (county[i] != "") {
                                    $scope.autocomplete.county.push({
                                        name: county[i]
                                    });
                                }
                            }
                        }

                        var comunity = $scope.group.filter.comunity;
                        if (comunity) {
                            comunity = comunity.split(",");
                            for (var i = 0; i < comunity.length; i++) {
                                if (comunity[i] != "") {
                                    $scope.autocomplete.comunity.push({
                                        name: comunity[i]
                                    });
                                }
                            }
                        }

                        var city = $scope.group.filter.city;
                        if (city) {
                            city = city.split(",");
                            for (var i = 0; i < city.length; i++) {
                                if (city[i] != "") {
                                    $scope.autocomplete.city.push({
                                        name: city[i]
                                    });
                                }
                            }
                        }

                        var street = $scope.group.filter.street;
                        if (street) {
                            street = street.split(",");
                            for (var i = 0; i < street.length; i++) {
                                if (street[i] != "") {
                                    $scope.autocomplete.street.push({
                                        name: street[i]
                                    });
                                }
                            }
                        }

                        $scope.show = true;

                        $scope.list = response.list;
                    });
            } else {
                $http.post('/administration/recivers/notifications')
                    .success(function(response) {
                        $scope.list = response.list;
                        $scope.data.activeNotifications = response.activeNotifications;
                    });
                _$breadcrumbs.push('Dodawanie grupy');
            }
        });
    };
    $scope._init();

    $scope.search = function() {
        var params = angular.copy($scope.group.filter);

        if ($scope.autocomplete.city.length > 0)
            params.city = _.map($scope.autocomplete.city, 'name').join();
        if ($scope.autocomplete.county.length > 0)
            params.county = _.map($scope.autocomplete.county, 'name').join();
        if ($scope.autocomplete.comunity.length > 0)
            params.comunity = _.map($scope.autocomplete.comunity, 'name').join();
        if ($scope.autocomplete.street.length > 0)
            params.street = _.map($scope.autocomplete.street, 'name').join();

        if (typeof params.age_before == "object")
            params.age_before = $rootScope.formatDate(params.age_before);
        if (typeof params.age_after == "object")
            params.age_after = $rootScope.formatDate(params.age_after);

        if (typeof $scope.group.subunits != "undefined" && $scope.group.subunits.length > 0)
            params.unit_id = $scope.group.subunits.join();

        params.active = 1;
        params.verified = 1;
        params.contact = 1;

        var promise = recipientService.list(1, params);
        promise.then(
            function(payload) {
                $scope.list = payload.data;
            },
            function(errorPayload) {
                $rootScope.notification.show('error', 'Błąd pobierania listy odbiorców po filtrowaniu');
            });
    };
});
